export enum DraftJobChangeType {
  UPDATE = 'UPDATE',
  REMOVE = 'REMOVE',
  ADD_JOB = 'ADD_JOB',
  SPLIT_JOB = 'SPLIT_JOB',
  REMOVE_JOB = 'REMOVE_JOB',
  BLOCKED = 'BLOCKED'
}
